import { useState, useEffect } from "react";
import api from "../../axiosconfig";
import { toast } from "react-toastify";

const defaultSummaries = {
    physical: "",
    emotional: "",
    acceptance: "",
    relationships: "",
    lovingKindness: "",
    intelligence: "",
};

export default function usePearliAiSummary(viewMode, scores, loadingScores) {
    const [summaries, setSummaries] = useState(defaultSummaries);
    const [aiSummary, setAiSummary] = useState("");
    const [prevSummary, setPrevSummary] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (viewMode !== "current") return;
        if (loadingScores) return;

        const fetchAiSummary = async () => {
            try {
                setLoading(true);

                if (aiSummary) setPrevSummary(aiSummary);

                const payload = [
                    scores.physical,
                    scores.emotional,
                    scores.acceptance,
                    scores.relationships,
                    scores.lovingKindness,
                    scores.intelligence,
                ];

                // Don't call API if all scores are null or no valid data
                const hasValidData = payload.some(s => s !== null && typeof s === 'number');
                if (!hasValidData) {
                    console.log("[usePearliAiSummary] Skipping AI analysis - no valid score data");
                    setSummaries(defaultSummaries);
                    setAiSummary("");
                    return;
                }

                const res = await api.post("/api/pearli/analyze", {
                    scores: payload,
                });

                const d = res?.data?.data;
                if (!d) {
                    setSummaries(defaultSummaries);
                    return;
                }

                setSummaries({
                    physical: d.PhysicalSummary || "",
                    emotional: d.EmotionalSummary || "",
                    acceptance: d.AcceptanceSummary || "",
                    relationships: d.RelationshipSummary || "",
                    lovingKindness: d.LovingKindnessSummary || "",
                    intelligence: d.IntellectualSummary || "",
                });

                setAiSummary(d.GeneralSummary || "");
            } catch {
                toast.error("Failed to load AI analysis.");
                setSummaries(defaultSummaries);
            } finally {
                setLoading(false);
            }
        };

        fetchAiSummary();
    }, [scores, viewMode, loadingScores]);

    return { summaries, aiSummary, prevSummary, loading };
}
